<template>
  <eg-b-container>
    <section class="p-3">
      <eg-b-row v-if="!premiumPlan">
        <eg-b-col md="12">
          <h1>{{ $t("dashboard.freePremiumTrial") }}</h1>
          <hr />
          <p>
            {{ $t("dashboard.trialDescription") }}
          </p>
          <p>
            {{ $t("dashboard.trialCoupon") }}
          </p>
          <p>{{ $t("dashboard.thankYou") }}</p>

          <eg-b-button variant="info" @click="getFreeTrial">
            {{ $t("dashboard.getFreeTrial") }}
          </eg-b-button>
        </eg-b-col>
      </eg-b-row>
    </section>
  </eg-b-container>
</template>

<script>
import { checkout } from "@/api";
import { SSK_PLAN_CHANGE_PENDING } from "@/constants";

export default {
  methods: {
    async getFreeTrial() {
      const session = await checkout({
        plan: "premium",
        yearly: false,
        trial: true,
      });

      const { id: userId, plan: currentPlan } = this.$store.state.user || {};
      if (userId && currentPlan) {
        sessionStorage.setItem(
          SSK_PLAN_CHANGE_PENDING,
          `${userId}|${currentPlan}`
        );
      }
      window.location.href = session.data.url;
    },
  },
};
</script>
